var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.877 4.356a7.25 7.25 0 0 1-2.08.57 3.63 3.63 0 0 0 1.592-2.004 7.227 7.227 0 0 1-2.299.879 3.622 3.622 0 0 0-6.169 3.303A10.281 10.281 0 0 1 2.46 3.32a3.622 3.622 0 0 0 1.12 4.834 3.611 3.611 0 0 1-1.64-.453v.047a3.622 3.622 0 0 0 2.905 3.55 3.647 3.647 0 0 1-1.635.062 3.622 3.622 0 0 0 3.382 2.514 7.265 7.265 0 0 1-5.36 1.5A10.239 10.239 0 0 0 6.778 17c6.66 0 10.302-5.516 10.302-10.3 0-.156-.004-.313-.011-.468a7.36 7.36 0 0 0 1.805-1.873l.002-.003Z",
    fill: "#55ACEE"
  })));
};
export default SvgTwitter;